export const jscompetencia = [{id: 1,descripcion: 'Federal'},{id: 2,descripcion: 'Estatal'},{id: 3,descripcion: 'Municipal'}];

export const jstipoacuerdo = [{id: 1,descripcion: 'Emplazamiento'},{id: 2,descripcion: 'No Irregularidades'}];


export const jstipodia = [{id: 1,descripcion: 'Habiles'},{id: 2,descripcion: 'No Habiles'}];


export const jsrespuesta = [{id: 1,descripcion: 'Positiva'},{id: 2,descripcion: 'Negativa'},{id: 3,descripcion: 'Pendiente'}];